export function isEnumMember<V, T extends { [key: string]: V }>(
  enumObj: T,
  value: V
): value is T[keyof T] {
  return Object.values(enumObj).includes(value);
}
